import { useState } from "react";
import { Link } from "react-router-dom";
import Layout, { Breadcrumb } from "@/components/feature/Layout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  usePageMeta({
    title: "漫画软件应用常见问题 - 哪个好一看就懂",
    description:
      "汇总漫画软件应用挑选与使用的高频疑问：哪个好用、免费追更、正版日漫、漏更管理、下载注意事项等，一看就懂。",
    canonical: "https://mangao0.github.io/faq",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    },
  });

  return (
    <Layout title="常见问题">
      <Breadcrumb crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />

      <div className="mx-auto w-full max-w-4xl px-4 pb-16 pt-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
            <i className="ri-question-line" aria-hidden="true"></i>
            FAQ
          </span>
          <h1 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">漫画软件应用常见问题</h1>
          <p className="mt-2 text-sm text-foreground-600">关于漫画软件应用哪个好用、免费追更与正版选择的常见疑问解答</p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f) => {
            const open = openId === f.id;
            return (
              <div key={f.id} className={`overflow-hidden rounded-2xl border bg-background-100 transition-colors ${open ? "border-primary-300" : "border-background-200/80"}`}>
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : f.id)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <h2 className="flex items-start gap-2.5 text-sm font-bold text-foreground-950 md:text-base">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500 text-xs font-black text-background-50">
                      Q
                    </span>
                    {f.question}
                  </h2>
                  <i className={`shrink-0 text-lg text-foreground-600 transition-transform ${open ? "rotate-180 text-primary-600" : ""}`} aria-hidden="true"></i>
                </button>
                {open && (
                  <div className="border-t border-background-200/80 px-5 pb-5 pt-4">
                    <p className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-700">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-black text-accent-700">
                        A
                      </span>
                      {f.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-2xl border border-background-200/80 bg-background-100 p-6 text-center">
          <h2 className="text-base font-bold text-foreground-950">还有问题没解决？</h2>
          <p className="mt-2 text-sm text-foreground-600">欢迎联系我们，也可以先看看完整的漫画软件应用排行榜。</p>
          <div className="mt-4 flex flex-col justify-center gap-3 sm:flex-row">
            <Link to="/contact" className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
              联系我们
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <Link to="/rankings" className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-lg border-2 border-primary-500 px-6 py-2.5 text-sm font-bold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50">
              查看排行榜
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}